export default "__VITE_ASSET__g92piQTB__"